export const INITIAL_AUTOMATION_STRATEGIES = [
  "none",
  "agent",
  "menu",
  "flow",
  "integration",
];

export const inferInitialAutomationStrategy = ({
  initialAutomationStrategy,
  promptId,
  flowIdWelcome,
  integrationId,
  queueIds = [],
}) => {
  if (INITIAL_AUTOMATION_STRATEGIES.includes(initialAutomationStrategy)) {
    return initialAutomationStrategy;
  }
  if (promptId) return "agent";
  if (flowIdWelcome) return "flow";
  if (integrationId) return "integration";
  if (queueIds.length) return "menu";
  return "none";
};

export const buildInitialAutomationPayload = ({
  strategy,
  promptId,
  flowIdWelcome,
  integrationId,
}) => ({
  initialAutomationStrategy: strategy,
  promptId: strategy === "agent" && promptId ? promptId : null,
  flowIdWelcome: strategy === "flow" && flowIdWelcome ? flowIdWelcome : null,
  integrationId:
    strategy === "integration" && integrationId ? integrationId : null,
});

export const initialAutomationConfigurationError = ({
  strategy,
  promptId,
  flowIdWelcome,
  integrationId,
  queueIds = [],
}) => {
  if (strategy === "agent" && !promptId) return "Selecione o agente de entrada";
  if (strategy === "menu" && !queueIds.length) return "Selecione ao menos uma fila para o menu";
  if (strategy === "flow" && !flowIdWelcome) return "Selecione o fluxo de boas-vindas";
  if (strategy === "integration" && !integrationId) return "Selecione a integração externa";
  return null;
};
